<template>
  <div class="user">
    <div class="photo">
      <router-link to="/profile">
        <img :src="user.image">
      </router-link>
    </div>
    <div class="border-b border-gray-500 mt-12 pb-2 mx-1"></div>
  </div>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions'
  import { mapState } from 'vuex';
  import BaseAvatar from 'src/components/BaseAvatar';

  export default {
    components: {
      CollapseTransition,
      BaseAvatar
    },
    data() {
      return {
        isClosed: true
      }
    },
    computed: {
      ...mapState('user', {
        user: state => state.user.user
      })
    },
  }
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
</style>
